import { render, staticRenderFns } from "./AddLeaveRequest.vue?vue&type=template&id=2b265daa&scoped=true"
import script from "./AddLeaveRequest.vue?vue&type=script&lang=js"
export * from "./AddLeaveRequest.vue?vue&type=script&lang=js"
import style0 from "./AddLeaveRequest.vue?vue&type=style&index=0&id=2b265daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b265daa",
  null
  
)

export default component.exports